import { useEffect } from "react";

/**
 * 특정 조건에서 핀치 줌(Pinch Zoom) 및 더블탭 줌을 비활성화하는 훅
 *
 * CSS `touch-action`과 JS 터치 이벤트 차단을 함께 적용하여
 * 삼성 인터넷 등 user-scalable=no 메타 태그를 무시하는 브라우저에도 대응합니다.
 *
 * @param enabled - true일 때 핀치 줌 방지 활성화
 */
export function useDisablePinchZoom(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    // 1. CSS touch-action으로 핀치 줌 차단
    // 삼성 인터넷 등 메타 태그를 무시하는 브라우저에서 가장 확실한 방법
    document.documentElement.style.touchAction = "pan-x pan-y";
    document.body.style.touchAction = "pan-x pan-y";

    // 2. JS 이벤트로 멀티터치 및 더블탭 줌 차단 (CSS 미지원 환경 대응)
    const preventPinchStart = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    const preventPinchMove = (e: TouchEvent) => {
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    };

    let lastTouchEnd = 0;
    const preventDoubleTapZoom = (e: TouchEvent) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    };

    document.addEventListener("touchstart", preventPinchStart, {
      passive: false,
    });
    document.addEventListener("touchmove", preventPinchMove, {
      passive: false,
    });
    document.addEventListener("touchend", preventDoubleTapZoom, {
      passive: false,
    });

    return () => {
      document.documentElement.style.touchAction = "";
      document.body.style.touchAction = "";
      document.removeEventListener("touchstart", preventPinchStart);
      document.removeEventListener("touchmove", preventPinchMove);
      document.removeEventListener("touchend", preventDoubleTapZoom);
    };
  }, [enabled]);
}
